<template>
  <!-- min-h-dvh 而不是 min-h-screen：手機瀏覽器的網址列會伸縮，100vh 是最大值、會被工具列蓋住底部 -->
  <div class="flex min-h-dvh">
    <!-- 左側：頁面內容 -->
    <div class="flex-1 flex flex-col justify-center items-center bg-mx-canvas relative">
      <slot></slot>
      <!-- 產品仍在 beta：放左上角與語言選擇器對稱；右側品牌欄手機會隱藏，所以不掛在那裡 -->
      <div class="absolute top-4 left-4">
        <BetaBadge />
      </div>
      <!-- 語言選擇器 -->
      <div class="absolute top-4 right-4">
        <LanguageSelector />
      </div>
    </div>
    <!-- 右側：動畫或引導圖，由頁面透過 useAuthLayoutMedia 指定 -->
    <div class="hidden md:flex w-[35%] bg-gray-800 items-center justify-center">
      <AuthAnimation v-if="media.type === 'animation'" />
      <div v-else class="p-[10%]">
        <img :src="media.src" class="object-cover" @error="showWizardImage()" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AuthAnimation from '~/components/auth/AuthAnimation.vue';
import BetaBadge from '~/components/common/BetaBadge.vue';
import LanguageSelector from '~/components/common/LanguageSelector.vue';
import { useAuthLayoutMedia } from '~/composables/useAuthLayoutMedia';

const { media, showWizardImage } = useAuthLayoutMedia();
</script>
